import { graphql } from '@/gql';
import type { RenewActivePartnerCallerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const renewActivePartnerCaller = async ({ callerId, startDate }: RenewActivePartnerCallerMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      startDate,
    },
    mutation: graphql(`
      mutation RenewActivePartnerCaller($callerId: String!, $startDate: String!) {
        renewActivePartnerCaller(callerId: $callerId, startDate: $startDate) {
          id
          callerId
          planName
          nextPlanName
          periodStartAt
          periodEndAt
          expectedPeriodEndAt
          isTrial
          transactionId
          timePlanSuspendPeriodStartDate
          timePlanSuspendPeriodEndDate
        }
      }
    `),
  });

  return response.data?.renewActivePartnerCaller;
};
